import React from 'react';

import SettingsIcon from '@atlaskit/icon/core/settings';

export const ManageSpaceIconV2 = (): React.JSX.Element => (
	<SettingsIcon label="" spacing="spacious" />
);
